import {createBrowserRouter, createMemoryRouter, RouteObject, RouterProvider} from "react-router"

import {LoginGate, LogoutGate, UserTypeCrossroads} from "./components/authGates"
import Layout from "./components/Layout"
import {AdminIndex} from "./routes/Admin/index.tsx"
import MatchingDetails from "./routes/Admin/Matching/Details/index.tsx"
import Matching, {MatchingIndex} from "./routes/Admin/Matching/index.tsx"
import Sellings, {SellingsIndex} from "./routes/Admin/Sellings/index.tsx"
import {CompanyPreview} from "./routes/Company/CompanyPreview.tsx"
import {CompanyProfile} from "./routes/Company/CompanyProfile.tsx"
import {CompanyTransactions} from "./routes/Company/CompanyTransactions.tsx"
import {Company} from "./routes/Company/index.tsx"
import {MyCompanyGate} from "./routes/Company/MyCompanyGate.tsx"
import {stepCompanyProfile, stepCompanyTransactions} from "./routes/Company/stepsConfig.ts"
import {CookiesPage} from "./routes/Cookies/CookiesPage.tsx"
import {CreateSalesCycle} from "./routes/CreateSalesCycle/CreateSalesCycle.tsx"
import {DashboardCompany} from "./routes/DashboardCompany/DashboardCompany.tsx"
import {WelcomeScreen} from "./routes/DashboardCompany/WelcomeScreen/WelcomeScreen.tsx"
import {DashboardSaaSCompany} from "./routes/DashboardSaaSCompany/DashboardSaaSCompany.tsx"
import DashboardSalesperson from "./routes/DashboardSalesperson/index.tsx"
import {Flags} from "./routes/Flags.tsx"
import {PasswordResetRequest} from "./routes/ForgottenPassword/PasswordResetRequest.tsx"
import {PasswordResetVerification} from "./routes/ForgottenPassword/PasswordResetVerification.tsx"
import {Deleted} from "./routes/GDPR/Deleted.tsx"
import {GDPR} from "./routes/GDPR/index.tsx"
import {HowItWorks} from "./routes/HowItWorks/index.tsx"
import {KlaraDashboard} from "./routes/KlaraDashboard/KlaraDashboard.tsx"
import Landing from "./routes/Landing"
import {Leads} from "./routes/Leads/index.tsx"
import {LogIn} from "./routes/LogIn.tsx"
import {OnboardingSaaSCompany} from "./routes/OnboardingSaaSCompany/OnboardingSaaSCompany.tsx"
import {AdminProspects} from "./routes/Prospects/Admin/index.tsx"
import {CompanyProspects} from "./routes/Prospects/Company/index.tsx"
import {SaasCompanyProspects} from "./routes/Prospects/SaasCompany/index.tsx"
import {SaasSalespersonProspects} from "./routes/Prospects/SaasSalesperson"
import {SalespersonProspects} from "./routes/Prospects/Salesperson/index.tsx"
import {ReachEngine} from "./routes/ReachEngine"
import {ReachEngineGate} from "./routes/ReachEngine/ReachEngineGate"
import {AdminReports} from "./routes/Reports/AdminReports.tsx"
import {Reports} from "./routes/Reports/index.tsx"
import {SaaSUserManagement} from "./routes/SaaSUserManagement/SaaSUserManagement.tsx"
import {SalesAssistant} from "./routes/SalesAssistant/SalesAssistant.tsx"
import {SalesForm} from "./routes/SalesForm/index.tsx"
import {Salesperson} from "./routes/Salesperson/index.tsx"
import {MySalespersonGate} from "./routes/Salesperson/MySalespersonGate.tsx"
import {SalespersonLearning} from "./routes/Salesperson/SalespersonLearning.tsx"
import {SalespersonPreview} from "./routes/Salesperson/SalespersonPreview.tsx"
import {AdditionalInformation} from "./routes/SalesStrategy/AdditionalInformation.tsx"
import Benefits from "./routes/SalesStrategy/Benefits.tsx"
import Completed from "./routes/SalesStrategy/Completed.tsx"
import ElevatorPitch from "./routes/SalesStrategy/ElevatorPitch.tsx"
import SalesStrategy from "./routes/SalesStrategy/index.tsx"
import MarketPresence from "./routes/SalesStrategy/MarketPresence.tsx"
import References from "./routes/SalesStrategy/References.tsx"
import {
  stepAdditionalInformation,
  stepBenefits,
  stepElevatorPitch,
  stepMarketPresence,
  stepReferences,
  stepUniqueness,
  stepWeb,
} from "./routes/SalesStrategy/stepsConfig.ts"
import Uniqueness from "./routes/SalesStrategy/Uniqueness.tsx"
import Web from "./routes/SalesStrategy/Web.tsx"
import {SellingDetails as SellingDetailsCompanyAndAdmin} from "./routes/SellingDetails/CompanyAndAdmin/SellingDetails.tsx"
import {SellingDetails as SellingDetailsSalesperson} from "./routes/SellingDetails/Salesperson/SellingDetails.tsx"
import {DetailsTab} from "./routes/SellingDetails/shared/tabs/DetailsTab.tsx"
import {NewsTab} from "./routes/SellingDetails/shared/tabs/NewsTab.tsx"
import {SignUpPick} from "./routes/SignUp"
import {AccountCreatePage as CompanyAccountCreatePage} from "./routes/SignUp/Company/AccountCreatePage.tsx"
import {EmailFormPage as CompanyEmailFormPage} from "./routes/SignUp/Company/EmailFormPage.tsx"
import {RegistrationUnavailablePage} from "./routes/SignUp/Company/Managing/RegistrationUnavailablePage.tsx"
import {AccountCreatePage as SaaSCompanyAccountCreatePage} from "./routes/SignUp/SaaSCompany/AccountCreatePage.tsx"
import {AccountCreatePage as SaaSSalespersonAccountCreatePage} from "./routes/SignUp/SaaSSalesperson/AccountCreatePage.tsx"
import {AccountCreatePage as SalespersonAccountCreatePage} from "./routes/SignUp/Salesperson/AccountCreatePage.tsx"
import {EmailFormPage as SalespersonEmailFormPage} from "./routes/SignUp/Salesperson/EmailFormPage.tsx"
import {AUserTypes} from "./services/types.generated"
import {RouterError} from "./RouterError"

export const routes: RouteObject[] = [
  {id: "flags", path: "/flags", element: <LoginGate Component={Flags} />},
  {
    id: "root",
    path: "/",
    element: <Layout />,
    errorElement: <RouterError />,
    children: [
      {
        id: "landing",
        index: true,
        element: <Landing />,
      },
      {
        id: "cookies",
        path: "cookies",
        Component: CookiesPage,
      },
      {
        id: "log-in",
        path: "log-in",
        element: <LogoutGate Component={LogIn} />,
      },
      {
        path: "sign-up",
        children: [
          {
            id: "sign-up",
            index: true,
            element: <LogoutGate Component={SignUpPick} />,
          },
          {
            path: "company",
            children: [
              {
                id: "sign-up-company",
                index: true,
                element: <LogoutGate Component={CompanyEmailFormPage} />,
              },
              {
                id: "sign-up-company-managing",
                path: "managing",
                element: <LogoutGate Component={RegistrationUnavailablePage} />,
              },
            ],
          },
          {
            id: "sign-up-sales",
            path: "sales",
            element: <LogoutGate Component={SalespersonEmailFormPage} />,
          },
        ],
      },
      {
        path: "verification",
        children: [
          {
            id: "verification-company",
            path: "company",
            element: <LogoutGate Component={CompanyAccountCreatePage} />,
          },
          {
            id: "verification-sales",
            path: "sales",
            element: <LogoutGate Component={SalespersonAccountCreatePage} />,
          },
          {
            path: "saas",
            children: [
              {
                id: "verification-saas-company",
                path: "company",
                element: <LogoutGate Component={SaaSCompanyAccountCreatePage} />,
              },
              {
                id: "verification-saas-sales",
                path: "sales",
                element: <LogoutGate Component={SaaSSalespersonAccountCreatePage} />,
              },
            ],
          },
        ],
      },
      {
        path: "forgotten-password",
        children: [
          {
            id: "forgotten-password",
            index: true,
            element: <PasswordResetRequest />,
          },
          {
            id: "forgotten-password-verification",
            path: "verification",
            element: <PasswordResetVerification />,
          },
        ],
      },
      {
        path: "privacy-request",
        children: [
          {
            id: "privacy-request",
            index: true,
            Component: GDPR,
          },
          {id: "privacy-request-deleted", path: "deleted", Component: Deleted},
        ],
      },
      {
        id: "create-selling",
        path: "create-selling/:salesCycleId/:page?/:orderId?",
        element: <LoginGate Component={CreateSalesCycle} userTypes={[AUserTypes.CompanyUser]} />,
      },
      {
        id: "dashboard",
        path: "dashboard/:tab?",
        element: (
          <UserTypeCrossroads
            signpost={{
              [AUserTypes.CompanyUser]: DashboardCompany,
              [AUserTypes.SalesPerson]: DashboardSalesperson,
              [AUserTypes.SaasCompanyUser]: DashboardSaaSCompany,
              [AUserTypes.SaasSalesPerson]: DashboardSaaSCompany,
            }}
          />
        ),
      },
      {
        id: "sales-assistant",
        path: "sales-assistant",
        element: (
          <UserTypeCrossroads
            signpost={{
              [AUserTypes.SaasSalesPerson]: SalesAssistant,
              [AUserTypes.SaasCompanyUser]: KlaraDashboard,
            }}
          />
        ),
      },
      {
        id: "reach-engine",
        path: "reach-engine",
        element: (
          <LoginGate
            Component={() => <ReachEngineGate Component={ReachEngine} />}
            userTypes={[AUserTypes.CompanyUser, AUserTypes.SaasCompanyUser]}
          />
        ),
      },
      {
        id: "welcome",
        path: "welcome",
        element: <LoginGate Component={WelcomeScreen} userTypes={[AUserTypes.CompanyUser]} />,
      },
      {
        id: "onboarding",
        path: "onboarding",
        element: <LoginGate Component={OnboardingSaaSCompany} userTypes={[AUserTypes.SaasCompanyUser]} />,
      },
      {
        id: "how-it-works",
        path: "how-it-works",
        element: <LoginGate Component={HowItWorks} userTypes={[AUserTypes.CompanyUser]} />,
      },
      {
        id: "company-prospects",
        path: "prospects/:salesCycleId",
        element: <LoginGate Component={CompanyProspects} userTypes={[AUserTypes.CompanyUser]} />,
      },
      {
        id: "leads",
        path: "leads",
        element: <LoginGate Component={Leads} userTypes={[AUserTypes.Admin, AUserTypes.SalesPerson]} />,
      },
      {
        id: "selling-details",
        path: "sellings/:salesCycleId",
        element: (
          <UserTypeCrossroads
            signpost={{
              [AUserTypes.CompanyUser]: SellingDetailsCompanyAndAdmin,
              [AUserTypes.SaasCompanyUser]: SellingDetailsCompanyAndAdmin,
              [AUserTypes.SaasSalesPerson]: SellingDetailsSalesperson,
              [AUserTypes.SalesPerson]: SellingDetailsSalesperson,
              [AUserTypes.Admin]: SellingDetailsCompanyAndAdmin,
            }}
          />
        ),
        children: [
          {
            id: "selling-news",
            path: "news",
            element: (
              <LoginGate
                Component={NewsTab}
                userTypes={[
                  AUserTypes.CompanyUser,
                  AUserTypes.SaasCompanyUser,
                  AUserTypes.SaasSalesPerson,
                  AUserTypes.SalesPerson,
                  AUserTypes.Admin,
                ]}
              />
            ),
          },
          {
            id: "selling-reports",
            path: "reports/:metric?",
            element: (
              <LoginGate
                Component={Reports}
                userTypes={[
                  AUserTypes.CompanyUser,
                  AUserTypes.SaasCompanyUser,
                  AUserTypes.Admin,
                  AUserTypes.SalesPerson,
                  AUserTypes.SaasSalesPerson,
                ]}
              />
            ),
          },
          {
            id: "selling-prospects",
            path: "prospects",
            element: (
              <UserTypeCrossroads
                signpost={{
                  [AUserTypes.CompanyUser]: CompanyProspects,
                  [AUserTypes.Admin]: AdminProspects,
                  [AUserTypes.SaasCompanyUser]: SaasCompanyProspects,
                  [AUserTypes.SaasSalesPerson]: SaasSalespersonProspects,
                  [AUserTypes.SalesPerson]: SalespersonProspects,
                }}
              />
            ),
          },
          {
            id: "selling-details-tab",
            path: "details",
            element: (
              <LoginGate
                Component={DetailsTab}
                userTypes={[AUserTypes.CompanyUser, AUserTypes.Admin, AUserTypes.SalesPerson]}
              />
            ),
          },
        ],
      },
      {
        id: "sales-form",
        path: "sales-form/:salesCycleId?",
        element: <LoginGate Component={SalesForm} userTypes={[AUserTypes.CompanyUser]} />,
      },
      {
        id: "sales-strategy-completed",
        path: "sales-strategy-completed",
        element: <LoginGate Component={Completed} userTypes={[AUserTypes.CompanyUser]} />,
      },
      {
        id: "sales-strategy",
        path: "sales-strategy/:salesCycleId",
        element: <LoginGate Component={SalesStrategy} userTypes={[AUserTypes.CompanyUser]} />,
        children: [
          {
            id: "sales-strategy-web",
            path: stepWeb.href,
            element: <Web />,
          },
          {
            id: "sales-strategy-elevator-pitch",
            path: stepElevatorPitch.href,
            element: <ElevatorPitch />,
          },
          {
            id: "sales-strategy-benefits",
            path: stepBenefits.href,
            element: <Benefits />,
          },
          {
            id: "sales-strategy-uniqueness",
            path: stepUniqueness.href,
            element: <Uniqueness />,
          },
          {
            id: "sales-strategy-references",
            path: stepReferences.href,
            element: <References />,
          },
          {
            id: "sales-strategy-market-presence",
            path: stepMarketPresence.href,
            element: <MarketPresence />,
          },
          {
            id: "sales-strategy-additional-information",
            path: stepAdditionalInformation.href,
            element: <AdditionalInformation />,
          },
        ],
      },
      {
        id: "company-preview",
        path: "company/:companyId",
        element: <CompanyPreview />,
      },
      {
        id: "my-company",
        path: "company/:companyId?",
        element: <MyCompanyGate Component={Company} redirectToCurrentIfUndef />,
        children: [
          {
            id: "my-company-profile",
            path: stepCompanyProfile.href,
            element: <CompanyProfile />,
          },
          {
            id: "my-company-transactions",
            path: stepCompanyTransactions.href,
            element: <CompanyTransactions />,
          },
        ],
      },
      {
        id: "salesperson-preview",
        path: "salesperson/:salespersonId",
        element: <SalespersonPreview />,
      },
      {
        path: "salesperson/:salespersonId?",
        children: [
          {
            id: "my-salesperson-learning-materials",
            path: "learning-materials",
            element: <MySalespersonGate Component={SalespersonLearning} redirectToCurrentIfUndef />,
          },
          {
            id: "my-salesperson",
            path: ":tab?",
            element: <MySalespersonGate Component={Salesperson} redirectToCurrentIfUndef />,
          },
        ],
      },
      {
        id: "admin",
        path: "admin",
        element: <LoginGate Component={AdminIndex} userTypes={[AUserTypes.Admin]} />,
        children: [
          {
            id: "admin-prospects",
            path: "prospects/:salesCycleId",
            Component: AdminProspects,
          },
          {
            id: "admin-matching-layout",
            path: "matching",
            Component: MatchingIndex,
            children: [
              {
                path: ":tab",
                children: [
                  {
                    id: "admin-matching",
                    index: true,
                    element: <Matching />,
                  },
                  {
                    path: "detail/:id",
                    children: [
                      {
                        id: "admin-matching-details",
                        index: true,
                        element: <MatchingDetails />,
                      },
                      {
                        id: "admin-matching-assignment",
                        path: "assignment/:assignmentId",
                        element: <MatchingDetails />,
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "admin-sellings-layout",
            path: "sellings",
            Component: SellingsIndex,
            children: [
              {
                path: ":tab",
                children: [
                  {
                    id: "admin-sellings",
                    index: true,
                    element: <Sellings />,
                  },
                ],
              },
            ],
          },
          {
            id: "admin-reports",
            path: "sellings/:salesCycleId/reports/:metric?",
            Component: AdminReports,
          },
        ],
      },
      {
        id: "user-management",
        path: "user-management/:tab?",
        element: <LoginGate Component={SaaSUserManagement} userTypes={[AUserTypes.SaasCompanyUser]} />,
      },
    ],
  },
]

export const createAppBrowserRouter = () => createBrowserRouter(routes)

type MemoryRouterOptions = NonNullable<Parameters<typeof createMemoryRouter>[1]>

export const createAppMemoryRouter = (options: MemoryRouterOptions = {}) => createMemoryRouter(routes, options)

let browserRouter: ReturnType<typeof createAppBrowserRouter> | undefined

const getBrowserRouter = () => {
  browserRouter ??= createAppBrowserRouter()
  return browserRouter
}

const Router = () => <RouterProvider router={getBrowserRouter()} />

export default Router
